import { createBrowserRouter, Navigate } from 'react-router-dom'
import Layout from '@/components/layout/Layout'
import { RequireAuth, RequireRole, RequireProfile } from '@/components/common/Guards'
import LoginPage from '@/pages/LoginPage'
import SetPasswordPage from '@/pages/SetPasswordPage'
import CompleteProfilePage from '@/pages/CompleteProfilePage'
import DashboardPage from '@/pages/DashboardPage'
import ProjectsPage from '@/pages/ProjectsPage'
import ProjectFormPage from '@/pages/ProjectFormPage'
import ProjectCardPage from '@/pages/ProjectCardPage'
import UsersPage from '@/pages/UsersPage'
import GipStaffPage from '@/pages/GipStaffPage'
import UserDetailPage from '@/pages/UserDetailPage'
import AuditPage from '@/pages/AuditPage'
import HelpPage from '@/pages/HelpPage'

const DIRECTOR_ROLES = ['director', 'deputy_director'] as const

export const router = createBrowserRouter([
  // Публичные маршруты (без авторизации)
  { path: '/login', element: <LoginPage /> },
  { path: '/set-password', element: <SetPasswordPage /> },

  // Заполнение профиля — требует авторизации, но НЕ требует profile_completed
  {
    path: '/complete-profile',
    element: (
      <RequireAuth>
        <CompleteProfilePage />
      </RequireAuth>
    ),
  },

  {
    element: (
      <RequireAuth>
        <RequireProfile>
          <Layout />
        </RequireProfile>
      </RequireAuth>
    ),
    children: [
      { index: true, element: <Navigate to="/dashboard" replace /> },
      {
        // Главный экран доступен всем ролям; данные фильтруются по роли на бэкенде
        path: '/dashboard',
        element: <DashboardPage />,
      },
      { path: '/projects', element: <ProjectsPage /> },
      {
        path: '/projects/new',
        element: (
          <RequireRole roles={[...DIRECTOR_ROLES]}>
            <ProjectFormPage />
          </RequireRole>
        ),
      },
      { path: '/projects/:id', element: <ProjectCardPage /> },
      {
        path: '/users',
        element: (
          <RequireRole roles={[...DIRECTOR_ROLES]}>
            <UsersPage />
          </RequireRole>
        ),
      },
      {
        // ГИП приглашает проектировщиков (запрос ГГП, октябрь 2026)
        path: '/staff',
        element: (
          <RequireRole roles={['chief_engineer']}>
            <GipStaffPage />
          </RequireRole>
        ),
      },
      {
        path: '/users/:id',
        element: (
          <RequireRole roles={[...DIRECTOR_ROLES]}>
            <UserDetailPage />
          </RequireRole>
        ),
      },
      {
        path: '/audit',
        element: (
          <RequireRole roles={[...DIRECTOR_ROLES]}>
            <AuditPage />
          </RequireRole>
        ),
      },
      {
        // Руководства пользователя — доступны всем ролям (содержимое фильтруется по роли)
        path: '/help',
        element: <HelpPage />,
      },
    ],
  },

  { path: '*', element: <Navigate to="/projects" replace /> },
])
